// Common
import PermissionsIcon from '$common/icons/permissions-icon'
// Helpers
import { toLocale } from '$func/text'
// logic
import {
  useGroupChangeablePermissionsCount,
  useHall,
} from '$logic/hall/react-hook'
import { openGroupMemberPermissions, openHallSubscribers } from '$logic/router'
import { MemberPermissions } from '$logic/types/subscription'
import { HallAdminsActionItem } from '$common/hall-admin-action-item'
import { useRoom } from '$logic/room/react-hook'
import { useClientUserPermissions } from '$logic/subscription/react-hook'
// Localization
import { t } from '$i18n'
import { GroupIcon } from '$common/icons'
import { HallRemovedUsersProfileActionItem } from './components/hall-removed-users-profile-action-item'
import { ChatProfileActionItem } from '$common/chat-profile-action-item'

interface Props {
  isGroup: boolean
  hallId: string
  permissions: MemberPermissions
}

export function HallSettingsActions({ isGroup, hallId, permissions }: Props) {
  const { entity: hall, loading: hallLoading } = useHall(hallId)
  const room = useRoom(hallId)
  const clientUserPermissions = useClientUserPermissions(hallId)

  const {
    allowedPermissionsCount,
    permissionsCount,
    loading: hallPermissionsItemsLoading,
  } = useGroupChangeablePermissionsCount(hallId)

  return (
    <>
      {isGroup && (
        <ChatProfileActionItem
          Icon={<PermissionsIcon sx={{ color: 'secondary.main' }} />}
          onClick={() => openGroupMemberPermissions(hallId)}
          secondaryText={`${toLocale(allowedPermissionsCount)}/${toLocale(
            permissionsCount,
          )}`}
          secondaryTextLoading={hallPermissionsItemsLoading}
        >
          {t('profile.hall.actions.membersPermissions')}
        </ChatProfileActionItem>
      )}

      {/* {permissions.inviteViaLink && (
        <HallInvitationLinksProfileActionItem hallId={hallId} />
      )} */}

      <ChatProfileActionItem
        Icon={<GroupIcon />}
        onClick={() => openHallSubscribers(hallId)}
        secondaryText={
          room?.type === 'CHANNEL'
            ? clientUserPermissions?.isOwner
              ? toLocale(hall?.membersCount || '')
              : ''
            : toLocale(hall?.membersCount || '')
        }
        secondaryTextLoading={hallLoading}
        iconBgColor="secondary500"
      >
        {isGroup
          ? t('profile.hall.actions.members')
          : t('profile.hall.actions.subscribers')}
      </ChatProfileActionItem>

      <HallAdminsActionItem hallId={hallId} />

      {permissions.banUsers && (
        <HallRemovedUsersProfileActionItem hallId={hallId} />
      )}
    </>
  )
}
